module.exports = __webpack_public_path__ + "media/images/menu-fdc57fd4ccfcc9973afd64d433a16cde.svg";